module.exports = __webpack_public_path__ + "img/final_01.c1210fe6.png";